import RestService from '../RestService';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FontIcon from 'material-ui/FontIcon';

import Paper from 'material-ui/Paper';
import {cyan500} from 'material-ui/styles/colors';
import * as React from 'react';
import {CSSProperties} from 'react';

import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

const spacing = {
    iconSize: 24,
    desktopGutter: 24,
    desktopGutterMore: 32,
    desktopGutterLess: 8,
    desktopGutterMini: 8,
    desktopKeylineIncrement: 60,  // left-nav width = this * 4
    desktopDropDownMenuItemHeight: 32,
    desktopDropDownMenuFontSize: 15,
    desktopLeftNavMenuItemHeight: 30,
    desktopSubheaderHeight: 48,
    desktopToolbarHeight: 56,
};

const muiTheme = getMuiTheme({
spacing : spacing,
});

const styles = {
    section : {
        width: '100%',
        height:'100%',
        position: 'fixed',
        backgroundColor: cyan500,
        display: 'flex',
        maxWidth: 'none',
    } as CSSProperties,
    div : {
        display:'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        resize: 'verticle',
        width: '50%',
        height: '70%',
        margin: 'auto',
    } as CSSProperties,
    paper : {
        padding: '3%',
        textAlign: 'center',
        display: 'block',
        resize: 'verticle',
    } as CSSProperties,
    textField : {
        width: '100%',
        maxWidth:'300px',
        display: 'block',
        margin: 'auto',
    } as CSSProperties,
    raisedButton : {
        margin: '2%',
        marginTop: '4%',
        marginBottom: '5%',
        width: '50%',
    } as CSSProperties,
};
interface Props {

}

interface State {
    password?: string;
    confirmPassword?: string;
    passwordMatch?: boolean;
    generatedHash?: string;
}

class ResetPassword extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            passwordMatch : false,
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    onSubmit() {
        const that = this;
        RestService.generateHash(this.state.password, (hash: string, error: string) => {
            if (hash) {
                that.setState({
                    ...that.state,
                    generatedHash: hash,
                });
            } else {
                that.setState({
                    ...that.state,
                    generatedHash: 'Error generating hash',
                });
            }
        });
    }

    handleChange = (event: any) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        let password, confirmPassword;
        if (name == 'password') {
            password = value;
            confirmPassword = this.state.confirmPassword;
        } else if (name == 'password_retype') {
            password = this.state.password;
            confirmPassword = value;
        }

        const passmatch = password ? confirmPassword == password : false;
        this.setState({
            ...this.state,
            password : password,
            confirmPassword : confirmPassword,
            passwordMatch: passmatch,
        });
    }

    render() {
        console.log(this.state);
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <section style={styles.section}>
                    <div style={styles.div}>
                        <Paper style={styles.paper} zDepth={3}>
                            <h3>Reset Password</h3>
                            <form onSubmit={(e) => {e.preventDefault(); this.onSubmit();}}>
                                <TextField
                                    key='password'
                                    style={styles.textField}
                                    floatingLabelText='New Password'
                                    type='password'
                                    name='password'
                                    onChange={this.handleChange}
                                />
                                <TextField
                                    key='password_retype'
                                    style={styles.textField}
                                    floatingLabelText='Retype Password'
                                    type='password'
                                    name='password_retype'
                                    onChange={this.handleChange}
                                    errorText={!this.state.passwordMatch && (this.state.password ? true: false) ? 'Passwords do not match' : ''}
                                />
                                <RaisedButton
                                    label='Create Hash'
                                    type='submit'
                                    primary={true}
                                    style= {styles.raisedButton}
                                    disabled={!this.state.passwordMatch}
                                    icon={<FontIcon className='material-icons'>vpn_key</FontIcon>}
                                />
                            </form>
                            {
                                this.state.generatedHash ?
                                <div>
                                    <div style={{margin:'5px'}}>{'Hash: '+ this.state.generatedHash}</div>
                                    <span style={{margin:'5px'}}>Mail the generated hash to glance-eng@glance.app</span>
                                </div>
                                : ''
                            }
                        </Paper>
                    </div>
                </section>
            </MuiThemeProvider>
        );
    }
}

export default ResetPassword;


// WEBPACK FOOTER //
// ./src/components/ResetPassword.tsx